import { removeTokenInfo } from './token';

/**
 * 约课成功后传递数据给app
 * @param data - 约课成功后的数据
 */
export const sentBookClassInfoToApp = (data: any) => {
  if (data) {
    const dataJSON = JSON.stringify(data);
    window?.webkit?.messageHandlers?.COURSE_RESERVE_SUCCESS?.postMessage?.(
      dataJSON,
    );
    window?.AppBridge?.COURSE_RESERVE_SUCCESS?.(dataJSON);
  }
};

/**
 * 返回app首页
 *
 */
export const backAppHome = () => {
  window?.webkit?.messageHandlers?.BACK?.postMessage?.('');
  window?.AppBridge?.BACK?.('');
};

/**
 * 进线成功后传递数据给app， 用于 app 进行AF数据上报
 * @param data - 进线成功后的数据
 */
export const sendLeadInfoToApp = (data: any) => {
  if (data) {
    const dataJSON = JSON.stringify(data);
    window?.webkit?.messageHandlers?.CallNative_AfPoint?.postMessage?.(
      dataJSON,
    );
    window?.AppBridge?.CallNative_AfPoint?.(dataJSON);
  }
};

/**
 * 通知app端关闭验证码弹窗
 */
export const closeCaptcha = (message?: string) => {
  window?.webkit?.messageHandlers?.CallNative_AlibabacloudVerifyDismiss?.postMessage?.(
    message || '',
  );
  window?.AppBridge?.CallNative_AlibabacloudVerifyDismiss?.(message || '');
};

/**
 * 通知app端发送验证码成功
 */
export const sendCodeSuccess = () => {
  window?.webkit?.messageHandlers?.CallNative_AlibabacloudVerifySuccess?.postMessage?.(
    '',
  );
  window?.AppBridge?.CallNative_AlibabacloudVerifySuccess?.('');
};

export const onPageReady = () => {
  window?.webkit?.messageHandlers?.CallNative_Ready?.postMessage?.('');
  window?.AppBridge?.CallNative_Ready?.('');
};

/**
 *h5告诉源生开启/关闭webview侧滑返回
 *0：关闭 1：开启
 */
export const changeBackForwardGesture = (isOpen: boolean) => {
  window?.webkit?.messageHandlers?.CallNative_changeBackForwardGesture?.postMessage?.(
    isOpen ? '1' : '0',
  );
  window?.AppBridge?.CallNative_changeBackForwardGesture?.(isOpen ? '1' : '0');
};

/**
 * h5告诉原生开启关闭音频后台播放
 * @param isOpen - 是否开启
 */
export const changeAudioBackgroundPlay = (isOpen: boolean) => {
  window?.webkit?.messageHandlers?.CallNative_changeNativeAudioPlayback?.postMessage?.(
    isOpen ? '1' : '0',
  );
  window?.AppBridge?.CallNative_changeNativeAudioPlayback?.(isOpen ? '1' : '0');
};
